import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import type { FormControl } from '@angular/forms';

import { FieldType } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-radio-group',
	template: `
		<div [attr.data-test-id]="field.id" class="my-3">
			<vp-radio-group
				[customFormControl]="radioGroupFormControl"
				[disabled]="props.disabled"
				[hasError]="showError"
				[horizontal]="props['horizontal']"
				[initialValue]="formControl.value"
				[inputId]="field.id"
				[isValid]="formControl.valid"
				[name]="field.key.toString()"
				[options]="props['radioOptions']"
				[readonly]="props.readonly"
				[shouldTranslate]="props['translate']"
				ngDefaultControl
			/>
		</div>
	`,
	standalone: false,
})
export class RadioGroupComponent extends FieldType implements OnInit {
	radioGroupFormControl: FormControl;

	ngOnInit(): void {
		this.radioGroupFormControl = this.formControl as FormControl;
	}
}
